export enum VerifyRoutePathsEnum {
  EMAIL_VERIFY = '/verify',
}
